import Parser from 'html-react-parser';

/**
 * @param {string} content
 */
export function TextBlock({ content }) {
    return <div className="tiny-mce-content-body p-4">{Parser(content)}</div>;
}
